import { useTranslation } from "react-i18next";

const pillars = [
  {
    key: 1,
    image:
      "https://storage.readdy-site.link/project_files/123cd24f-3c94-48d0-9c42-347ad31c80a7/06de0151-e9da-47ee-89cb-2cba20dbbed2_compressed_-2026-07-24-20.41.39.webp",
    objectPosition: "object-center",
    inset: "inset-0",
  },
  {
    key: 2,
    image:
      "https://storage.readdy-site.link/project_files/123cd24f-3c94-48d0-9c42-347ad31c80a7/3be5e952-2366-4482-8311-cf884f6b5c29_compressed_kailingpiano-changsha-concert-hall-1529893.webp",
    objectPosition: "object-center",
    inset: "inset-0",
  },
  {
    key: 3,
    image:
      "https://storage.readdy-site.link/project_files/123cd24f-3c94-48d0-9c42-347ad31c80a7/1fecc59f-503c-4b54-8b19-8b26d31edd82_compressed_-2026-07-26-0.46.47.webp",
    objectPosition: "object-center",
    inset: "inset-0",
  },
];

export default function ThreePillars() {
  const { t } = useTranslation();

  return (
    <section id="pillars" className="relative bg-midnight py-32 md:py-44 overflow-hidden">
      <div className="w-full px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-8 items-end mb-24 md:mb-32">
          <div className="lg:col-span-4">
            <span className="text-warmgray text-xs font-sans tracking-widest uppercase">
              / {t("threepillars.label")}
            </span>
          </div>
          <div className="lg:col-span-8">
            <h2 className="text-marble font-serif text-xs md:text-3xl lg:text-5xl font-light leading-snug tracking-wide whitespace-pre-line">
              {t("threepillars.title")}
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {pillars.map((p) => (
            <div
              key={p.key}
              className="group relative overflow-hidden rounded-xl aspect-[3/4]"
            >
              <div
                className={`absolute ${p.inset} overflow-hidden rounded-lg transition-transform duration-700 group-hover:scale-105`}
              >
                <img
                  src={p.image}
                  alt=""
                  className={`w-full h-full object-cover ${p.objectPosition} brightness-[0.9] contrast-[1.08] saturate-[0.82]`}
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-deepblack/90 via-deepblack/30 to-transparent" />
              <div className="absolute inset-0 flex flex-col justify-end p-6 md:p-8">
                <p className="text-champagne text-xs font-sans tracking-widest uppercase mb-2">
                  {t(`threepillars.pillar${p.key}.subtitle`)}
                </p>
                <h3 className="text-marble font-serif text-xl md:text-2xl font-light tracking-wide mb-2">
                  {t(`threepillars.pillar${p.key}.title`)}
                </h3>
                <p className="text-marble/60 text-sm font-sans leading-relaxed whitespace-pre-line">
                  {t(`threepillars.pillar${p.key}.desc`)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}